import '@mdi/font/css/materialdesignicons.css';
import '@/styles/vuetifySettings.scss';
import type { ThemeDefinition } from 'vuetify';

import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { VMaskInput } from 'vuetify/labs/VMaskInput';

import { brandConfig } from '@/brand';

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: brandConfig.vuetifyPrimary,
    secondary: brandConfig.vuetifySecondary,
  },
};

const darkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    primary: brandConfig.vuetifyPrimary,
    secondary: brandConfig.vuetifySecondary,
  },
};

export default createVuetify({
  components: {
    ...components,
    VMaskInput,
  },
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
  },
});
